import axios from "axios";

const getEntity = (mutation, url) => {
  return axios
    .get(url + "/" + mutation + ".json", {
      baseURL: process.env.BASE_URL,
    })
    .then((res) => {
      return res.data;
    });
};

//Set data in store
export const set = (property) => (state, payload) => {
  state[property] = payload;
}
//Get data from store
export const get = (property) => (state) => {
  if (property in state) return state[property];
  console.error(`[vuex] unknown getter property: ${property}`);
  return;
};

//Get core mutation name
const getMutation = (property) => property;
//Set payload in storeFemail
const setMutation = (property) => (store, payload) => {
  var mutation = getMutation(property);
  store.commit(mutation, payload);
};

//Core fetch action
export const fetch = (mutation, url) => (store) => {
  return getEntity(mutation, url || "assets/languages/" + store.state.selectedLanguage.name).then((data) => {
    if (data.source) {
      setMutation(mutation)(store, data.source);
    }
    if (data.description) {
      setMutation(mutation + "Desc")(store, data.description);
    }
    if (!data.source) {
      setMutation(mutation)(store, data);
    }
    return data;
  });
};

export const mapProperties = (properties) => {
  const res = {};
  normalizeMap(properties).forEach(({
    key,
    val
  }) => {
    var keyName = key;
    res[keyName] = {};
    res[keyName].get = function mappedGetter() {
      if (!(val in this.$store.getters)) {
        console.error(`[vuex] unknown getter: ${val}`);
        return;
      }
      return this.$store.getters[val];
    };

    res[keyName].set = function mappedMutation(...args) {
      return this.$store.commit.apply(this.$store, [val].concat(args));
    };
    // mark vuex getter for devtools
    res[keyName].get.vuex = true;
  });
  return res;
};

function normalizeMap(map) {
  return Array.isArray(map) ?
    map.map((key) => ({
      key,
      val: key,
    })) :
    Object.keys(map).map((key) => ({
      key,
      val: map[key],
    }));
}

export default {
  fetch,
  set,
  get,
};